import React from "react";
import { Dialog } from '@fluentui/react';
import TempEnvironmentAdmins from "./TempEnvironmentAdmins";


const TempEnvironmentAdminsModal = ({environment, isModalOpened, onCloseModal}) => {
    
    return (
        <div>
            <Dialog
                hidden={!isModalOpened}
                onDismiss={onCloseModal}
                modalProps={{
                    isBlocking: false,
                }}
                dialogContentProps={{
                    title: `Add temporary administrators to Environment: ${environment.name}`
                }}
                minWidth={400}
                maxWidth={1000} >
                    <TempEnvironmentAdmins environmentId={environment.id}/>
            </Dialog>
        </div>
    );
}

export default TempEnvironmentAdminsModal




// WEBPACK FOOTER //
// ./src/components/Administration/PowerPlatform/TempEnvironmentAdminsModal.js